module.exports = __webpack_public_path__ + "static/media/c-sharp.c5b653fd.png";